export const aciLogout = {
    iconName: 'logout',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 23 24' },
        path: {
            attr: {
                d: 'M16.574 6.667a8 8 0 100 10.667M20.39 12H7.945M16.834 9.332l3.556 2.667-3.556 2.666',
                stroke: 'currentColor',
                'stroke-linecap': 'round',
            },
        },
    },
};
